<div bsModal #etiquetasModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="false" [config]="{ backdrop: 'static',keyboard: false}">
    <div class="modal-dialog modal-primary" role="document" style="max-width: 80%">
        <div class="modal-content ">
            <div class="modal-header">
                <h4 class="modal-title">Etiquetas </h4>
                <br><small>* Atenção todos os campos abaixo devem ser preechidos.</small>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="alert alert-danger" *ngIf="errors.length > 0">
                        <ul>
                            <li *ngFor="let error of errors">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group" [formGroup]="etiquetasForm">
                            <div class="form-group row">
                                <label class="col-md-2 control-label">Planta: </label>
                                <div class="col-md-10">
                                    <select class="form-control" formControlName="empresaECentroDestinoId"
                                        id="empresaECentroDestinoId">
                                        <option *ngFor="let item of empresasECentrosDestino" value="{{ item.id }}">
                                            {{ item.centro }} - {{ item.descricao }}</option>
                                    </select>
                                    <span class="text-danger" *ngIf="displayMessage.empresaECentroDestinoId">
                                        <p [innerHTML]="displayMessage.empresaECentroDestinoId"></p>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-2 control-label">NFe: </label>
                                <div class="col-md-10">
                                    <input class="form-control" id="numNFe" type="number" formControlName="numNFe" />
                                    <span class="text-danger" *ngIf="displayMessage.numNFe">
                                        <p [innerHTML]="displayMessage.numNFe"></p>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-2 control-label">Volume: </label>
                                <div class="col-md-10">
                                    <input class="form-control" id="volume" type="text" formControlName="volume" />
                                    <span class="text-danger" *ngIf="displayMessage.volume">
                                        <p [innerHTML]="displayMessage.volume"></p>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-2 control-label">Qtd: </label>
                                <div class="col-md-8">
                                    <input class="form-control" id="qtd" type="number" formControlName="qtd" />
                                    <span class="text-danger" *ngIf="displayMessage.qtd">
                                        <p [innerHTML]="displayMessage.qtd"></p>
                                    </span>
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-primary" tooltip="Registrar etiqueta"
                                        (click)="registrarEtiqueta()">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div style="overflow-x: auto; max-height: 300px;">
                            <table class="table table table-bordered table-striped table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Planta</th>
                                        <th>NFe</th>
                                        <th>Volume</th>
                                        <th>Qtd</th>
                                        <th>Usuário</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let etiqueta of etiquetasPorPedidoDeCompra">
                                        <td>{{etiqueta.dataCriacao | date :'dd/MM/yyyy HH:mm'}}</td>
                                        <td>{{etiqueta.planta}}</td>
                                        <td>{{etiqueta.numNF}}</td>
                                        <td>{{etiqueta.volumesFaturados}}</td>
                                        <td>{{etiqueta.quantidadeMaterial}}</td>
                                        <td>{{etiqueta.usuario}}</td>
                                        <td>
                                            <button type="button" class="btn btn-secondary"
                                                tooltip="Imprimir etiqueta 74 x 74"
                                                (click)="imprimirEtiqueta(etiqueta, 280, 280)">
                                                <i class="fa fa-print"></i>
                                            </button>
                                            <small>- | -</small>
                                            <button type="button" class="btn btn-secondary"
                                                tooltip="Imprimir etiqueta 100 x 120"
                                                (click)="imprimirEtiqueta(etiqueta, 378, 454)">
                                                <i class="fa fa-print"></i>
                                            </button>
                                            <small>- | -</small>
                                            <button type="button" class="btn btn-secondary" tooltip="Remover etiqueta"
                                                (click)="removerEtiqueta(etiqueta)">
                                                <i class="fa fa-minus"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-sm-12">
                        <button type="button" class="btn btn-secondary" (click)="etiquetasModal.hide()">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header">
        <strong><b>Marcopolo</b> - Registrar Arquivo XML</strong>
    </div>
    <div class="card-body">
        <div>
            <div class="alert alert-danger" *ngIf="errors.length > 0">
                <h3 id="msgRetorno">Opa! Alguma coisa não deu certo:</h3>
                <ul>
                    <li *ngFor="let error of errors">{{ error }}</li>
                </ul>
            </div>
            <form method="post" (ngSubmit)="registrarXML()" [formGroup]="arquivoXMLForm" enctype="multipart/form-data"
                class="form-horizontal">
                <div class="form-group row">
                    <label class="col-md-3 control-label">Enviar arquivo XML Marcopolo</label>
                    <div class="col-md-9">
                        <input #arquivoXML type="file" accept="*.xml" formControlName="arquivoXML" />
                    </div>
                </div>
                <div class="my-4">
                    <button type="submit" class="btn btn-sm btn-primary">
                        <i class="fa fa-floppy-o fa-lg"></i> Salvar</button>
                    <button type="botton" class="btn btn-sm btn-dark" (click)="limparFormRegistarXML()">
                        <i class="fas fa-sync-alt"></i> Cancelar</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header"><strong>Pedidos de Compra disponíveis</strong></div>
    <div class="card-body">
        <form method="post" [formGroup]="filtrarPedidosDeComprasForm" enctype="multipart/form-data"
            class="form-horizontal">
            <div class="input-group">
                <div class="col-md-4">
                    <input class="form-control" id="pedidoCompra" type="text" formControlName="pedidoCompra"
                        placeholder="Pedido de Compra" />
                </div>
                <div class="col-md-4">
                    <input class="form-control" id="itemPedidoDeCompra" type="text" formControlName="itemPedidoDeCompra"
                        placeholder="Item do Pedido de Compra" />
                </div>
                <div class="col-md-2">
                    <button type="button" class="btn btn-secondary" tooltip="Carregar mais 60 Pedidos de Compra"
                        (click)="btnPaginacao()">
                        <i class="fas fa-search"></i>
                    </button>
                    <small>- | -</small>
                    <button type="button" class="btn btn-secondary" tooltip="Limpar Filtros"
                        (click)="limparFormFiltros()">
                        <i class="fas fa-eraser"></i>
                    </button>
                </div>
            </div>
        </form>
        <hr>
        <div style="overflow-x: auto; max-height: 400px;">
            <table class="table table-bordered table-striped table-sm">
                <thead>
                    <tr>
                        <th>Nº Pedido de Compra</th>
                        <th>Item do <br>Pedido de Compra</th>
                        <th>Código do Item</th>
                        <th>Quantidade</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor='let pedidoDeCompra of pedidosDeCompra'>
                        <td>{{ pedidoDeCompra.pedidoCompra }}</td>
                        <td>{{ pedidoDeCompra.itemPedido }}</td>
                        <td>{{ pedidoDeCompra.codigoMaterial }}</td>
                        <td>{{ pedidoDeCompra.quantidade }}</td>
                        <td>
                            <button id="editarUsuario" type="botton"
                                (click)="exibirEtiquetas(pedidoDeCompra.xmlBodyMarcopoloId)"
                                class="btn btn-sm btn-primary">
                                <i class="fas fa-ticket-alt"></i> Etiquetas</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-modal-etiqueta-marcopolo [etiqueta]="etiqueta" [larguraDaEtiqueta]="larguraDaEtiqueta"
    [alturaDaEtiqueta]="alturaDaEtiqueta" (btnFecharClicked)="fecharModalDaEtiqueta()">
</app-modal-etiqueta-marcopolo>